import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAffirmationSuggestionCategory } from "../../../services/api";
import Notiflix from "notiflix";

export default function AffirmationSuggestion() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { id, moduleId } = useParams();

  // Notiflix'i initialize et
  useEffect(() => {
    Notiflix.Notify.init({
      position: "top-right",
      timeout: 3000,
      clickToClose: true,
      pauseOnHover: true,
    });
  }, []);

  // Kategorileri fetch et
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await getAffirmationSuggestionCategory();
        if (response.categories) {
          setCategories(response.categories);
        }
      } catch (error) {
        console.error("Kategoriler alınırken hata:", error);
        Notiflix.Notify.failure("Kategoriler yüklenirken bir hata oluştu!");
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryClick = (slug) => {
    navigate(`/${id}/${moduleId}/affirmation-suggestion?slug=${slug}`);
  };

  return (
    <div className="min-h-screen bg-[#e8e9ed] px-4 py-6">
      <div className="max-w-sm mx-auto">
        {/* İçerik */}
        <div className="space-y-4">
          {loading ? (
            <div className="text-center py-12">
              <div className="inline-flex items-center space-x-2 text-gray-500">
                <div className="w-5 h-5 border-2 border-[#3DA7B5] border-t-transparent rounded-full animate-spin"></div>
                <span className="text-sm">Yükleniyor...</span>
              </div>
            </div>
          ) : categories.length > 0 ? (
            <div className="grid grid-cols-2 gap-3">
              {categories.map((category, index) => (
                <div
                  key={category.id}
                  onClick={() => handleCategoryClick(category.slug)}
                  className="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-lg border border-gray-100 hover:border-[#3DA7B5]/30 transform hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 overflow-hidden"
                  style={{
                    animationDelay: `${index * 50}ms`,
                    animation: 'fadeInUp 0.4s ease-out forwards'
                  }}
                >
                  <div className="relative h-28 w-full">
                    <img
                      src={category.image_url}
                      alt={category.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                    <div className="absolute bottom-2 left-2 right-2 z-10">
                      <h3 className="text-white text-xs font-semibold leading-tight">
                        {category.title}
                      </h3>
                    </div>
                    <div className="absolute top-2 right-2 z-10">
                      <div className="w-5 h-5 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                        <svg className="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-[#3DA7B5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-gray-600 font-medium mb-2">Henüz kategori yok</h3>
              <p className="text-gray-500 text-sm">Yakında yeni kategoriler eklenecek</p>
            </div>
          )}
        </div>
      </div>
      
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}